import {NgModule} from '@angular/core'
import {DetailProgramDescGraficaComponent} from './detail-program-desc-grafica/detail-program-desc-grafica.component'
import {ModalProgramDescGraficaComponent} from './modal-program-desc-grafica/modal-program-desc-grafica.component'
import {SearchProgramsDescGraficaComponent} from './search-programs-desc-grafica/search-programs-desc-grafica.component'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {BrowserModule} from '@angular/platform-browser'
import {CommonModule} from '@angular/common'
import {IconsTextModule} from '../icons-text/icons-text.module'
import {DescriptionModule} from '../../description/description.module'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
import {PipesModule} from '../../../pipes/pipes.module'
import {FormsModule} from '@angular/forms'
import {InfiniteScrollModule} from 'ngx-infinite-scroll'
import {SharedModule} from '../../shared/shared.module'
@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    IconsTextModule,
    DescriptionModule,
    NgbNavModule,
    PipesModule,
    FormsModule,
    InfiniteScrollModule,
    SharedModule
  ],
  declarations: [
    DetailProgramDescGraficaComponent,
    ModalProgramDescGraficaComponent,
    SearchProgramsDescGraficaComponent
  ],
  exports: [
    DetailProgramDescGraficaComponent,
    ModalProgramDescGraficaComponent,
    SearchProgramsDescGraficaComponent
  ],
  providers: []
})
export class ProgramDescGraficaModule {
}
